import {StyleSheet} from 'react-native'
import { CARD_SIZE } from '../../config/style';

export default StyleSheet.create({
    container: {
        width: CARD_SIZE.width,
        height: CARD_SIZE.height,
        maxWidth: CARD_SIZE.maxWidth
    }
})